import { AbstractControl, ValidationErrors } from "@angular/forms";

export const verifyPassword = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get("password");
    const passwordConfirm = control.get("passwordConfirm");

    return password && passwordConfirm && password.value !== passwordConfirm.value
        ? { passwordDoNotMatch: true }
        : null;
};
